import {
  AlertTriangleFilled,
  CheckCircleFilled,
  InfoCircle,
  InfoCircleFilled,
} from "@imwebme/clay-icons";

export const iconMap = {
  default: <InfoCircle colorToken="icon-sub" />,
  critical: <AlertTriangleFilled colorToken="icon-critical" />,
  warning: <AlertTriangleFilled colorToken="icon-warning" />,
  information: <InfoCircleFilled colorToken="icon-accent" />,
  success: <CheckCircleFilled colorToken="icon-success" />,
};
